import React, { useEffect, useState } from 'react';
import { useLocation } from 'react-router-dom';
import Header from '../components/Header';
import Footer from '../components/Footer';

const DebugSkipCash = () => {
  const location = useLocation();
  const [urlParams, setUrlParams] = useState({});
  const [localStorageData, setLocalStorageData] = useState({});
  const [sessionStorageData, setSessionStorageData] = useState({});

  useEffect(() => {
    // Get URL parameters
    const params = new URLSearchParams(location.search);
    const urlParamsObj = {};
    for (let [key, value] of params.entries()) {
      urlParamsObj[key] = value;
    }
    setUrlParams(urlParamsObj);

    // Get localStorage data
    const localData = {};
    for (let i = 0; i < localStorage.length; i++) {
      const key = localStorage.key(i);
      localData[key] = localStorage.getItem(key);
    }
    setLocalStorageData(localData);

    // Get sessionStorage data
    const sessionData = {};
    for (let i = 0; i < sessionStorage.length; i++) {
      const key = sessionStorage.key(i);
      sessionData[key] = sessionStorage.getItem(key);
    }
    setSessionStorageData(sessionData);
  }, [location]);

  return (
    <div>
      <Header />
      <div style={{ padding: '40px', maxWidth: '1200px', margin: '0 auto' }}>
        <h1>SkipCash Debug Information</h1>
        
        <div style={{ marginBottom: '30px' }}>
          <h2>URL Parameters</h2>
          <pre style={{ background: '#f5f5f5', padding: '15px', borderRadius: '4px', overflow: 'auto' }}>
            {JSON.stringify(urlParams, null, 2)}
          </pre>
        </div>

        <div style={{ marginBottom: '30px' }}>
          <h2>localStorage Data</h2>
          <pre style={{ background: '#f5f5f5', padding: '15px', borderRadius: '4px', overflow: 'auto' }}>
            {JSON.stringify(localStorageData, null, 2)}
          </pre>
        </div>

        <div style={{ marginBottom: '30px' }}>
          <h2>sessionStorage Data</h2>
          <pre style={{ background: '#f5f5f5', padding: '15px', borderRadius: '4px', overflow: 'auto' }}>
            {JSON.stringify(sessionStorageData, null, 2)}
          </pre>
        </div>

        <div style={{ marginBottom: '30px' }}>
          <h2>Current URL</h2>
          <pre style={{ background: '#f5f5f5', padding: '15px', borderRadius: '4px', overflow: 'auto' }}>
            {window.location.href}
          </pre>
        </div>

        <div style={{ marginBottom: '30px' }}>
          <h2>SkipCash Expected Parameters</h2>
          <ul>
            <li><strong>id:</strong> SkipCash payment ID</li>
            <li><strong>statusId:</strong> Payment status (2 = paid)</li>
            <li><strong>status:</strong> Payment status text</li>
            <li><strong>transId:</strong> Transaction ID (should start with ORDER-)</li>
            <li><strong>amount:</strong> Payment amount</li>
            <li><strong>custom1:</strong> Custom field (may contain order data)</li>
          </ul>
        </div>

        <div style={{ marginBottom: '30px', padding: '15px', background: '#d4edda', borderRadius: '4px' }}>
          <h3>Quick Analysis</h3>
          {urlParams.id ? (
            <p>✅ SkipCash payment ID found: {urlParams.id}</p>
          ) : (
            <p>❌ No SkipCash payment ID found</p>
          )}
          
          {urlParams.statusId === '2' ? (
            <p>✅ Payment successful (statusId=2)</p>
          ) : urlParams.statusId ? (
            <p>⚠️ Payment status: {urlParams.statusId} ({urlParams.status || 'Unknown'})</p>
          ) : (
            <p>❌ No payment status found</p>
          )}
          
          {urlParams.transId ? (
            <p>✅ Transaction ID found: {urlParams.transId}</p>
          ) : (
            <p>❌ No transaction ID found</p>
          )}
          
          {urlParams.amount ? (
            <p>✅ Payment amount: {urlParams.amount} QAR</p>
          ) : (
            <p>❌ No payment amount found</p>
          )}
          
          {localStorageData.cart || localStorageData.cartItems ? (
            <p>✅ Cart data found in localStorage</p>
          ) : (
            <p>❌ No cart data in localStorage</p>
          )}
        </div>
      </div>
      <Footer />
    </div>
  );
};

export default DebugSkipCash; 